import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from "flarum/forum/app";
import Model from "flarum/common/Model";
import { messagePreview } from "../utils/preview";

/**
 * Per-thread tracking level. Mirrors Ramon\Chat\ThreadUser.
 */
export let ThreadTracking = /*#__PURE__*/function (ThreadTracking) {
  ThreadTracking[ThreadTracking["Never"] = 0] = "Never";
  ThreadTracking[ThreadTracking["Mentions"] = 1] = "Mentions";
  ThreadTracking[ThreadTracking["Always"] = 2] = "Always";
  return ThreadTracking;
}({});
export default class Thread extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "title", Model.attribute("title"));
    _defineProperty(this, "status", Model.attribute("status"));
    _defineProperty(this, "channelId", Model.attribute("channelId"));
    _defineProperty(this, "originalMessageId", Model.attribute("originalMessageId"));
    _defineProperty(this, "repliesCount", Model.attribute("repliesCount"));
    _defineProperty(this, "lastMessageId", Model.attribute("lastMessageId"));
    _defineProperty(this, "lastMessageAt", Model.attribute("lastMessageAt", Model.transformDate));
    _defineProperty(this, "createdAt", Model.attribute("createdAt", Model.transformDate));
    // ── Per-actor tracking state ───────────────────────────────────────────────
    _defineProperty(this, "notificationLevel", Model.attribute("notificationLevel"));
    _defineProperty(this, "unreadCount", Model.attribute("unreadCount"));
    _defineProperty(this, "lastReadMessageId", Model.attribute("lastReadMessageId"));
    _defineProperty(this, "isParticipating", Model.attribute("isParticipating"));
    _defineProperty(this, "canRename", Model.attribute("canRename"));
    _defineProperty(this, "canPostMessage", Model.attribute("canPostMessage"));
    _defineProperty(this, "canClose", Model.attribute("canClose"));
    _defineProperty(this, "creator", Model.hasOne("creator"));
    _defineProperty(this, "channel", Model.hasOne("channel"));
    _defineProperty(this, "originalMessage", Model.hasOne("originalMessage"));
    _defineProperty(this, "lastMessage", Model.hasOne("lastMessage"));
  }
  isOpen() {
    return this.status() === "open";
  }
  hasUnread() {
    var _this$unreadCount;
    return ((_this$unreadCount = this.unreadCount()) != null ? _this$unreadCount : 0) > 0;
  }

  /**
   * Falls back to an excerpt of the root message when the thread has no title,
   * which is how an untitled thread stays identifiable in "My Threads".
   */
  displayTitle(excerptLength) {
    if (excerptLength === void 0) {
      excerptLength = 60;
    }
    const title = this.title();
    if (title) return title;

    // `hasOne` resolves to `false` when the relationship is not loaded, which is
    // distinct from a loaded-but-null relationship.
    const root = this.originalMessage();

    // Through `messagePreview`, not `content()`: the latter is the *source*, so a
    // thread branched off a bot announcement was titled `**[Chat Extension](/d/20)**`
    // — the markup rather than the words. Every other place that shows a message
    // inside something else already reads the rendered HTML; this one was missed.
    const content = root ? messagePreview(root, excerptLength) : "";
    if (!content) {
      return app.translator.trans("ramon-chat.forum.thread.untitled", {}, true);
    }
    return content;
  }
  apiEndpoint() {
    return "/chat-threads" + (this.exists ? "/" + this.id() : "");
  }
}
flarum.reg.add('ramon-chat', 'common/models/Thread', Thread);